import React, { useCallback, useEffect, useState } from 'react'
import { GlobalState } from '@leverege/ui-redux'
import { Text } from '@leverege/ui-elements'

import useHeatmap from '../hooks/useHeatmap'
import useBBoxes from '../../hooks/useBBoxes'

import S from './AisleImage.css'

export default function AisleImage( { item, src : pSrc, delegate, range } ) {
  const [ src, setSrc ] = useState()
  const [ loading, setLoading ] = useState( false )

  useEffect( () => {
    const rsrc = delegate.resource( 'resourceImage/image' ).getRsrc( GlobalState.get() )

    if ( rsrc ) {
      const url = new URL( rsrc.data.url )
      const expires = url.searchParams.get( 'Expires' )
      const expiresDate = new Date( parseInt( expires ) * 1000 )

      if ( expiresDate > new Date() ) {
        if ( rsrc.data.url !== src ) {
          setSrc( rsrc.data.url )
        }
        return
      }
    }

    setLoading( true )
    GlobalState
      .dispatch( delegate.resource( 'resourceImage/image' ).get() )
      .then( ( res ) => {
        setSrc( res.data.url )
        setLoading( false )
        return res
      } )
  }, [ delegate, src, pSrc ] )

  const { result } = useBBoxes( {
    delegate,
    id : item.id,
    range
  } )

  const { ref } = useHeatmap( {
    result,
    delegate,
    id : item.id,
    url : src
  } )

  if ( loading || !pSrc || !src ) {
    return (
      <div
        className={S.image}>
        {loading ? (
          <i
            className="fa fa-fw fa-spin fa-spinner fa-3x"
            style={{
              color : 'var(--color-brand500)',
            }}/>
        ) : (
          <Text variant="caption">No Image Available</Text>
        )}
      </div>
    )
  }

  return (
    <div
      ref={ref}
      className={S.image} />
  )
}
